import { action, makeObservable, observable } from 'mobx';

export default class TreeLinkNode {
  public next = null;
  public previous = null;
  public id = null;

  constructor(id: string | number) {
    makeObservable(this, {
      next: observable,
      previous: observable,
      id: observable,
      setNext: action,
      setPrevious: action
    });

    this.id = id;
  }

  //////////////////////////
  // Setters
  //////////////////////////

  setNext(node: TreeLinkNode) {
    this.next = node;
  }

  setPrevious(node: TreeLinkNode) {
    this.previous = node;
  }

  //////////////////////////
  // Getters
  //////////////////////////

  getPrevious() {
    return this.previous;
  }

  getNext() {
    return this.next;
  }

  getId() {
    return this.id;
  }
}
